module.exports = __webpack_public_path__ + "media/site/images/ecommerce/ecommerce-tested-solutions.en@2x-dab67ed47a1f8c08ecf96c2f05ce7bda.png";